export const PLUGIN_URL = "https://chromewebstore.google.com/detail/authory-browser-extension/gobopjkcfahjadhfkdpnadohcipjkkmj";
